import { inject, Injectable } from '@angular/core'
import type { Observable } from 'rxjs'

import { HttpService } from '@app/services/http.service'

import type { Source } from '../models/source'

@Injectable({ providedIn: 'root' })
export class FavoriteService {
  private readonly httpService = inject(HttpService)

  add(profileId: number, source: Source): Observable<unknown> {
    return this.httpService.post('favorites', { profile_id: profileId, routing: source })
  }

  remove(profileId: number, source: Source): Observable<unknown> {
    return this.httpService.delete(`favorites/remove_profile/${profileId}`, { params: { source } })
  }
}
